<template>
  <div class="oneui">
    <div
      class="center-div"
      style="position: fixed; width: 100vw; height: var(--top-padding)"
    >
      <ul class="nameWrapper" :style="`grid-template-columns: 1fr;`">
        <li></li>
        <li class="current">
          <span>{{ kid ? kid.get("name") : "" }}</span>
        </li>
        <li></li>
      </ul>
    </div>
    <div class="pageWrapper">
      <div class="page">
        <div id="choreContainer" class="kidsHome cardContainer">
          <reward
            :reward="kid ? kid.get('customReward') : null"
            :class="`${$root.parent && $root.parent.get('slimView') ? 'card-slim' : ''}`"
            mode="kids"
            :updater="$root"
            :kid="kid"
          />
          <div class="card allDone" v-show="isDone">
            <h3>{{ $t("pages.kids.goodJob") }}</h3>
            <p>{{ $t("pages.kids.done") }}</p>
          </div>
          <chore
            v-for="chore in openChores"
            :key="chore.id"
            :kid="kid"
            :chore="chore"
            mode="kids"
            @click.native="done(chore, 'chores')"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Reward from "@/components/Reward";
import Chore from "@/components/Chore";

export default {
  components: {
    Reward,
    Chore,
  },
  data() {
    return {
      child: null,
    };
  },
  computed: {
    kid() {
      const kids = this.$root.$data.kids || [];
      return kids[Number(this.child)] || null;
    },
    openChores() {
      const chores = this.$root.$data.chores || [];
      const list = chores[Number(this.child)];
      if (!list || !Array.isArray(list)) return [];
      return list.filter((_chore) => !_chore.get("done"));
    },
    isDone() {
      if (!this.kid) return false;
      return this.openChores.length === 0;
    },
  },
  methods: {
    async done(chore) {
      let confirm = await ModernModals.prompt(
        this.$t("pages.kids.confirmChore"),
        `Did you finish ${chore.get("name")}?`
      );
      if (confirm) {
        this.$router.push({
          path: "/kids/action/done/",
          query: {
            kid: this.$route.query.ind,
            chore: chore.id,
          },
        });
      }
    },
  },
  mounted() {
    this.$root.$data.locked = true;
    this.$data.child = this.$route.query.ind;
  },
};
</script>